import React from 'react';
import { Group, TextInput, Avatar, Center } from '@mantine/core';
import { DateInput } from '@mantine/dates';
import '@mantine/dates/styles.css';

interface PersonalInfoEditorProps {
  firstName: string;
  middleName?: string;
  lastName: string;
  dob?: Date | null;
  profileUrl?: string;
  onUpdateField: (field: string, value: any) => void;
  disabled?: boolean;
}

export const PersonalInfoEditor: React.FC<PersonalInfoEditorProps> = ({
  firstName,
  middleName,
  lastName,
  dob,
  profileUrl,
  onUpdateField,
  disabled = false,
}) => {
  return (
    <>
      <Center mb={30}>
        <Avatar 
          src={profileUrl} 
          radius="xl" 
          alt={`${firstName} ${lastName} profile photo`}
          size={180}
        />
      </Center>
      <Group grow align="flex-start">
        <TextInput
          size="md"
          label="First Name"
          placeholder="Enter first name"
          value={firstName}
          onChange={(e) => onUpdateField('firstName', e.currentTarget.value)}
          disabled={disabled}
          required
        />
        {middleName !== undefined && (
          <TextInput
            size="md"
            label="Middle Name"
            placeholder="Enter middle name"
            value={middleName || ''}
            onChange={(e) => onUpdateField('middleName', e.currentTarget.value || undefined)}
            disabled={disabled}
          />
        )}
        <TextInput
          size="md"
          label="Last Name"
          placeholder="Enter last name"
          value={lastName}
          onChange={(e) => onUpdateField('lastName', e.currentTarget.value)}
          disabled={disabled}
          required
        />
      </Group>
      <DateInput
        size="md"
        label="Date of Birth"
        placeholder="MM/DD/YYYY"
        value={dob}
        onChange={(value) => onUpdateField('dob', value)}
        valueFormat="MM/DD/YYYY"
        disabled={disabled}
        required
        mt="md"
        allowDeselect={false}
        clearable={false}
        preserveTime={false}
      />
    </>
  );
};
